import compose from "recompose/compose";
import ebg from './bg';
import inner from './inner';
import pattern from './pattern';
import { map, renders } from "./utils";
/**
 * @param props
 */


/**
 * transform
 * @param type
 */
const transform = (type: string) => ({ tl, tr, bl, br, or }: any) => {
	switch (type) {
		case 'top_left':      if (tl) { return `rotate(${tl} 50 50)`; } break;
		case 'top_right':     if (tr) { return `rotate(${tr} 50 50)`; } break;
		case 'bottom_right':  if (br) { return `rotate(${br} 50 50)`; } break;
		case 'other':         if (or) { return `rotate(${or} 50 50)`; } break;
		default:              if (bl) { return `rotate(${bl} 50 50)`; } break;
	}
}


{/*export default*/}
function eyes(props: any){
	let { x, y, type, custom, gb, width, params } = props || {};

	let { pattern, ebg, inner       } = props || {};
	let { eyeShape, eyeInner, eyeBg } = params || {};

	let dataType: string;

	if (x === y && x === 0) { dataType = 'top_left'; }
	else if (x > y) 			  { dataType = 'top_right'; }
	else if (x < y) 			  { dataType = 'bottom_left'; }
	else if(x > 0 && y > 0)	{ dataType = 'other'; }
	else 									  { dataType = 'bottom_right'; }

	eyeBg    = map('ebg',     eyeBg,    ebg);
	eyeShape = map('pattern', eyeShape, pattern);
	eyeInner = map('inner',   eyeInner, inner);

	eyeInner  = eyeInner[dataType];
	eyeShape  = eyeShape[dataType];
	eyeBg     = eyeBg[dataType];

	return renders({ x, y, type, custom, gb, width, eyeBg, eyeShape, eyeInner, dataType, transform: transform(dataType) });
}

const Eyes: any = compose(ebg, inner, pattern)(eyes)

export default Eyes;


